import styled from 'styled-components';

import { minWidth, units } from '@calm-web/design-system';

export const FtueWrapper = styled.div`
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	flex-grow: 1;
	width: 100%;
`;

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	background: linear-gradient(180deg, rgba(56, 159, 230, 0) 57.58%, rgba(56, 159, 230, 0.35) 100%);
	padding-bottom: ${units(1.25)};

	${minWidth('desktop')} {
		flex-direction: row;
		padding: 0 ${units(3.56)};
		justify-content: center;
	}
`;

export const ComponentWrapper = styled.div`
	width: 100%;

	${minWidth('desktop')} {
		width: unset;
		padding-bottom: ${units(2)};
		flex: 0 1 504px;
	}
`;

export const LoaderContainer = styled.div`
	height: 100vh;
`;
